module.exports = __webpack_public_path__ + "img/schedules.ec37e1d2.svg";